export const followNonAnchorLink = function (el) {
    const link = el.getAttribute("data-link");
    if (typeof link != "undefined" && link != "") {
        document.location.href = link;
    }
};
